export const LoadMessageDirection = {
  Up: 'up',
  Down: 'down',
} as const;
